export class BookingModelExtra {
  eventId?: number = -1;
  bookingID!: number;
  bookingDate!: Date;
  requestedTherapistID!: number;
  assignedTherapistID!: number;
  fullName!: string;
  mobileNumber!: string;
  contactMethodID!: number;
  location!: string;
  otherNotes!: string;
  bookingStatusID!: number;
  treatmentStart!: Date;
  treatmentEnd!: Date;
  bookingStatus!: string;
  activeMinutes?: number;
  therapistName?: string;
}
